interface Args {
  symbolString: string;
  brokerage: string;
}

export async function checkSymbol({ symbolString, brokerage }: Args) {
  let url = 'http://localhost:8080/';
  let fetchOptions: RequestInit = {
    method: 'GET',
    mode: 'cors',
    credentials: 'include',
    headers: {
      'Access-Control-Allow-Origin': '*',
    },
  };
  if (window?.config && window?.config?.REACT_APP_REDIRECT) {
    url = `${window.config.REACT_APP_REDIRECT}`;
    fetchOptions = {};
  }
  const requestUrl = `${url}symbol-exists?brokerage=${brokerage}&&symbol=${symbolString}`;
  let json;
  try {
    const result = await fetch(requestUrl, fetchOptions);
    json = await result.json();
  } catch (error) {
    console.log(error);
    json = { symbol: symbolString, exists: false };
  }
  return json;
}
